<script setup lang="ts">
import TermsAndConditionsContent from '@components/ui/prepay&terms-and-conditions/TermsAndConditionsContent.vue';
import PanelPageContainer from '@components/layout/org&panel&support/PanelPageContainer.vue';

const contentStore = useContentStore();
const siteConfigs = useSiteConfigs();
const siteTitle = siteConfigs.title;
const title = `شرایط و مقررات استفاده از خدمات ${siteTitle}`;
const desc = `شرایط و مقررات استفاده از خدمات وب سایت و اپلیکیشن ${siteTitle}`;
useServerHead({
    link: [
        {
            rel: 'canonical',
            href: 'https://mrbilit.com/support/terms-and-conditions',
        },
    ],
});
await useAsyncData(async () => {
    try {
        await contentStore.getTermsAndCondition();
        return true;
    } catch (e) {
        reportException(e);
    }
});
useSeoMeta({
    title,
    description: desc,
    ogTitle: title,
    ogDescription: desc,
});
</script>

<template>
    <PanelPageContainer retain-box-in-mobile title="شرایط و مقررات">
        <TermsAndConditionsContent />
    </PanelPageContainer>
</template>
